import React from 'react';
import defaultSleepImage1 from "../../../../assets/default-images/default-sleep-image-1.png";
import defaultSleepImage2 from "../../../../assets/default-images/default-sleep-image-2.png";
import defaultSleepImage3 from "../../../../assets/default-images/default-sleep-image-3.png";
import defaultSleepImage4 from "../../../../assets/default-images/default-sleep-image-4.png";
import defaultSleepImage6 from "../../../../assets/default-images/default-sleep-image-6.jpg";
import defaultSleepImage7 from "../../../../assets/default-images/default-sleep-image-7.jpg";
import defaultSleepImage8 from "../../../../assets/default-images/default-sleep-image-8.jpg";
import defaultSleepImage9 from "../../../../assets/default-images/default-sleep-image-9.jpg";
import defaultSleepImage10 from "../../../../assets/default-images/default-sleep-image-10.jpg";

const ReadArticlePreviewCardLeft = ({ imgSrc, title }) => {


    const defaultImgChoice = [
        defaultSleepImage1,
        defaultSleepImage2,
        defaultSleepImage3,
        defaultSleepImage4,
        defaultSleepImage6,
        defaultSleepImage7,
        defaultSleepImage8,
        defaultSleepImage9,
        defaultSleepImage10
    ];

    const randomImgNumber = Math.floor(Math.random() * 9);
    const imageUrl = imgSrc || defaultImgChoice[randomImgNumber];



    return (
        <div className="readArticlePreviewCard-left h-full sm:w-1/2 w-10/12 items-center flex flex-row">
            <div className="readArticlePreviewCard-image h-full w-2/5 sm:w-1/3 mr-4  sm:mr-8 bg-gold-accent bg-cover no-repeat bg-center rounded-lg" style={{backgroundImage: `url(${imageUrl})` }}></div>
            <div className="readArticlePreviewCard-title text-xxs w-3/5 sm:w-2/3 md:text-sm font-semibold text-dark-text-grey ">
                <p className={`sm:hidden`}>{title.length > 60 ? title.slice(0, 60) + "..." : title}</p>
                <p className={`hidden sm:block`}>{title}</p>
            </div>
        </div>
    );
};

export default ReadArticlePreviewCardLeft;